const demoTypes = [
    "Try demo", "Schedule demo", "Video demo", "Book meeting", "Request demo", "View demo" 
].sort();

export default demoTypes;

